/**
 * Environment-aware logger utility for React frontend
 * Disables debug/info logs in production to prevent information leakage
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Debug logging - only in development
   * Use for detailed debugging information
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Info logging - only in development
   * Use for general informational messages
   */
  info: (...args) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Warning logging - always enabled
   * Use for potential issues that don't stop execution
   */
  warn: (...args) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Error logging - always enabled
   * Use for errors and exceptions
   */
  error: (...args) => {
    console.error('[ERROR]', ...args);
  },

  /**
   * API logging - only in development
   * Use for API request/response debugging
   */
  api: (...args) => {
    if (isDevelopment) {
      console.log('[API]', ...args);
    }
  },

  /**
   * Socket logging - only in development
   * Use for WebSocket connection events
   */
  socket: (...args) => {
    if (isDevelopment) {
      console.log('[SOCKET]', ...args);
    }
  },

  /**
   * Payment logging - only in development
   * Use for payment-related events
   * Never log full card numbers, CVVs, or sensitive payment data
   */
  payment: (...args) => {
    if (isDevelopment) {
      console.log('[PAYMENT]', ...args);
    }
  }
};

export default logger;
